import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function RegistrationSuccess() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 8, mb: 4, textAlign: 'center' }}>
        <CheckCircleIcon sx={{ fontSize: 100, color: 'success.main', mb: 3 }} />

        <Typography variant="h3" gutterBottom fontWeight="bold">
          Welcome to SimplyPayroll!
        </Typography>

        <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
          Your registration is complete
        </Typography>

        <Card sx={{ mb: 4, textAlign: 'left' }}>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h5" gutterBottom sx={{ textAlign: 'center' }}>
              ✓ Account Created Successfully
            </Typography>

            <Box sx={{ mt: 3, mb: 3 }}>
              <Typography variant="body1" paragraph>
                Thank you for choosing SimplyPayroll! Your business account has
                been successfully created and your subscription is now active.
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>📧 Check Your Email</strong>
                <br />
                We've sent a confirmation email with your subscription details,
                including your plan, billing rate, and next renewal date.
              </Typography>
            </Box>

            <Box
              sx={{
                bgcolor: (theme) => theme.palette.custom.primaryTint,
                borderRadius: 2,
                padding: 3,
                mb: 3,
              }}
            >
              <Typography variant="h6" gutterBottom>
                Getting Started
              </Typography>
              <Box component="ol" sx={{ pl: 3, mb: 0 }}>
                <li>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Log in to your account</strong> using your email and
                    password
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Complete your business profile</strong> with tax IDs
                    and contact information
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Add your employees</strong> and set up their payroll
                    details
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Process your first payroll</strong> and generate
                    paystubs
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2">
                    <strong>Manage your subscription</strong> anytime from your
                    profile
                  </Typography>
                </li>
              </Box>
            </Box>

            <Box
              sx={{
                bgcolor: (theme) => theme.palette.custom.warningTint,
                borderRadius: 2,
                padding: 2,
                mb: 2,
              }}
            >
              <Typography variant="body2">
                <strong>💡 Need Help?</strong> Check out our help documentation
                or contact our support team at any time.
              </Typography>
            </Box>
          </CardContent>
        </Card>

        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => navigate('/login')}
          sx={{ minWidth: 250, py: 1.5 }}
        >
          Continue to Login
        </Button>

        <Box sx={{ mt: 3 }}>
          <Typography variant="body2" color="text.secondary">
            Ready to transform your payroll process? Let's get started!
          </Typography>
        </Box>
      </Box>
    </Container>
  );
}
